import { useStoreCart } from "./useStoreCart";

export const AddCommentSection = () => {
  const { setSavedValues } = useStoreCart();

  const onChangeComment = async (comment: string) => {
    setSavedValues((prev) => ({ ...prev, orderComment: comment }));
  };

  return (
    <div className="flex flex-col lg:my-10">
      <label htmlFor="orderComment" className="mb-2">
        TIlføj kommentar til ordren
      </label>
      <textarea
        id="orderComment"
        placeholder="Tilføj kommentar..."
        rows={1}
        onChange={(e) => onChangeComment(e.target.value)}
        className="w-full bg-white rounded-md border border-secondary-200 p-4 placeholder:text-sm"
      />
    </div>
  );
};
